<template>
    <div>
        <v-dialog v-model="show" persistent :overlay="false" max-width="1300px" transition="dialog-transition">
            <v-card>
                <v-toolbar dark color="secondary" dense>
                    <v-btn @click="sendDocuments()" icon><v-icon>mdi-send</v-icon></v-btn>
                    <v-spacer />
                    <v-toolbar-title class="white--text">Add Documents</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="$emit('close')" icon><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-container grid-list-xs>
                    <v-progress-linear v-model="porcent" v-show="viewBar" height="25">
                        <strong>{{ Math.ceil(porcent) }}%</strong>
                    </v-progress-linear>
                </v-container>
                <v-container grid-list-xs>
                    <v-list>
                        <v-list-item v-for="(item, idxItm) in documents" :key="idxItm + 'doc'">
                            <v-list-item-avatar>
                                <v-icon color="secondary">mdi-file-account-outline</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title v-text="item.File.name"></v-list-item-title>
                            </v-list-item-content>
                            <v-btn color="red" icon @click="dltRow(idxItm)"><v-icon>mdi-delete</v-icon></v-btn>
                            <v-list-item-action>
                                <v-row>
                                    <v-col cols="12">
                                        <v-combobox v-model="item.Document" :items="docTypes" :item-text="'Document'"
                                            :item-value="'id'"
                                            label="Select the corresponding document" hide-details dense
                                            width="300px"></v-combobox>
                                    </v-col>
                                </v-row>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-container>
            </v-card>
            <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios";
import ConfirmDialogue from './../../Modals/ConfirmDialogue.vue';
export default {
    components: {
        ConfirmDialogue
    },
    props: ['files', 'show', 'Driver'],
    data: function () {
        return {
            documents: [],
            porcent: 0,
            viewBar: false,
            sft:[],
            docTypes:[],
            filesDocs: [],
        }
    },
    methods: {
        createRows: async function () {
            await this.files.forEach(element => {
                // if (element.type === 'application/pdf' || element.type === 'image/jpeg') {
                const doc = {
                    Driver: this.Driver, //INT
                    Document: null, //INT
                    Name: element.name, //String
                    File: element //File
                }

                this.documents.push(doc);
                // }
            });
            console.log(this.documents);
        },


        async dltRow(idx) {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to Row File',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.documents.splice(idx, 1);
            }
        },
        sendDocuments: async function () {
            this.porcent = 0;
            const total = this.documents.length;
            const prc = 100 / total;
            this.viewBar = true;

            for (const [index, x] of this.documents.entries()) {
                if (x.Document === null || x.Document.documentId === undefined) {
                    x.Document = null;
                    this.viewBar = false;
                } else {
                    try {
                        console.log(x.File);
                        const formData = new FormData();
                        formData.append('file', x.File);
                        formData.append('Driver', x.Driver);
                        formData.append('Name', x.Name);
                        formData.append('Document', x.Document.documentId);

                        if(x.Document.SftId != null){
                            formData.append('SftMeeting', x.Document.SftId);
                        }
                        console.log(formData);

                        const response = await axios.post('driver-list/upload/files', formData, {
                            headers: {
                                Authorization: 'Bearer ' + this.$store.state.token,
                                'Content-Type': 'multipart/form-data'
                            }
                        });
                        this.documents.splice(index, 1);
                        console.log(response.data);

                        // Tareas después de la solicitud HTTP exitosa
                        this.porcent += prc;
                        console.log(prc);
                        if (this.porcent >= 99) {
                            this.$emit('updateDriver');
                            this.$emit('close');
                        }
                    } catch (error) {
                        logErr(error);
                    }
                }
            }

        },

        getDocuments: function () {
            this.$store.state.isLoading = true;
            axios
                .get('document/sft', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    await response.data.forEach((x,idx) => {
                        x['id'] = idx +1 ;
                    });
                    this.docTypes = response.data;
                    console.log(this.docTypes,'Here');
                })
                .catch(error => {
                    logErr(error);
                })
                .finally(() => {
                    this.$store.state.isLoading = false;
                });
        },
        
    },

    mounted() {
        this.getDocuments();
        this.createRows();
    },
}
</script>
